module.exports = __webpack_public_path__ + "static/media/logo-televisa.a2494dc7.svg";